import { forwardRef } from 'react';

/** 라벨 + 인풋 + 에러 한 줄. `.form-card>:not(:last-child)` 간격 규칙의 단위가 된다 */
const Field = forwardRef(function Field(
  { id, label, required, error, ...inputProps },
  ref,
) {
  return (
    <div>
      <label htmlFor={id} className={required ? 'field-label field-required' : 'field-label'}>
        {label}
      </label>
      <input
        ref={ref}
        id={id}
        name={id}
        className="field-input"
        required={required}
        aria-invalid={error ? 'true' : undefined}
        {...inputProps}
      />
      {required && (
        <strong className="field-error" data-error-for={id} hidden={!error}>
          {error}
        </strong>
      )}
    </div>
  );
});

export const FIELDS = [
  {
    id: 'company',
    label: '소속',
    required: true,
    type: 'text',
    placeholder: '소속을 입력해주세요.',
    autoComplete: 'organization',
    emptyMessage: '* 소속을 입력해주세요.',
  },
  {
    id: 'position',
    label: '직책',
    type: 'text',
    placeholder: '직책을 입력해주세요.',
    autoComplete: 'organization-title',
  },
  {
    id: 'name',
    label: '이름',
    type: 'text',
    placeholder: '이름을 입력해주세요.',
    autoComplete: 'name',
  },
  {
    id: 'email',
    label: '이메일 주소',
    required: true,
    type: 'email',
    placeholder: '이메일 주소를 입력해주세요.',
    autoComplete: 'email',
    emptyMessage: '* 이메일 주소를 입력해주세요.',
  },
  {
    id: 'phone',
    label: '휴대 전화번호',
    required: true,
    type: 'tel',
    placeholder: '010-0000-0000',
    autoComplete: 'tel',
    inputMode: 'numeric',
    emptyMessage: '* 휴대 전화번호를 입력해주세요.',
  },
];

/**
 * 신청서 폼.
 *
 * 동의 체크박스 하나(agreePrivacy)가 아래 개인정보 섹션에 있어서
 * form 요소 밖에 산다. 상태는 InquiryPage 가 들고 있고 여기로 내려온다.
 */
export function ContactForm({
  formId,
  fieldRefs,
  errors,
  onFieldInput,
  onSubmit,
  busy,
  agreeThird,
  agreeMarketing,
  onAgreeThirdChange,
  onAgreeMarketingChange,
  onOpenPrivacyModal,
}) {
  return (
    <form
      id={formId}
      noValidate
      className="form-card"
      onSubmit={onSubmit}
      aria-busy={busy || undefined}
    >
      {FIELDS.map(({ id, label, required, emptyMessage, ...inputProps }) => (
        <Field
          key={id}
          ref={fieldRefs[id]}
          id={id}
          label={label}
          required={required}
          error={errors[id]}
          onInput={() => onFieldInput(id)}
          {...inputProps}
        />
      ))}

      <fieldset>
        <legend className="mb-4 flex flex-wrap items-center gap-4">
          <span className="block-title">개인정보 수집 및 동의 안내</span>
          <button type="button" className="btn-outline-sm" onClick={onOpenPrivacyModal}>
            전문 확인하기
          </button>
        </legend>

        <div className="space-y-4">
          <label className="check-row" htmlFor="agreeThird">
            <input
              type="checkbox"
              id="agreeThird"
              name="agreeThird"
              required
              className="check-box"
              checked={agreeThird}
              onChange={(event) => onAgreeThirdChange(event.target.checked)}
            />
            <span className="field-required">개인정보 제3자 제공에 동의합니다.</span>
          </label>

          <label className="check-row" htmlFor="agreeMarketing">
            <input
              type="checkbox"
              id="agreeMarketing"
              name="agreeMarketing"
              className="check-box"
              checked={agreeMarketing}
              onChange={(event) => onAgreeMarketingChange(event.target.checked)}
            />
            <span>광고성 정보 수신 동의 (선택)</span>
          </label>
        </div>
      </fieldset>
    </form>
  );
}
